import React from 'react';
import { Row, Col, Divider } from 'antd'
import { COLOR, FONT } from '../constants';
import useResponsive from '../hooks/useResponsive'
import TNContent from './TNContent';

const BlockchainFAQ = () => {
  const { isMobile } = useResponsive();

  return (
    <TNContent maxWidth={1920}>
      <Row
        align='middle'
        justify='center'
        style={{ backgroundColor: COLOR.menuText, padding: '6% 0px' }}>
        <Col span={24}>
          <Row justify='center' gutter={[0, 24]} style={{ textAlign: 'center' }}>
            <Col xs={21} md={24}><span style={{ ...FONT.h5, color: COLOR.whiteText }}>What will I get ?</span></Col>
            <Col xs={4} md={2}><Divider style={{ border: '1px solid #C1C1C1', margin: 0 }} /></Col>
            <Col xs={21} md={24}><span style={{ ...FONT.h6, color: COLOR.whiteText }}>A free and unique Shiba9 NFT </span></Col>
          </Row>
          <Row justify='center' style={{ margin: '36px 0px' }}>
            <Col>
              <img src="./assets/star_up.gif" alt="" style={{ width: 30, marginRight: 10, marginLeft: 10 }} />
              <img src="./assets/star_down.gif" alt="" style={{ width: 30, marginRight: 10, marginLeft: 10 }} />
              <img src="./assets/star_up.gif" alt="" style={{ width: 30, marginRight: 10, marginLeft: 10 }} />
              <img src="./assets/star_down.gif" alt="" style={{ width: 30, marginRight: 10, marginLeft: 10 }} />
              <img src="./assets/star_up.gif" alt="" style={{ width: 30, marginRight: 10, marginLeft: 10 }} />
              <img src="./assets/star_down.gif" alt="" style={{ width: 30, marginRight: 10, marginLeft: 10 }} />
            </Col>
          </Row>
          <Row justify='center' gutter={[0, 24]} style={{ textAlign: 'center' }}>
            <Col xs={21} md={24}><span style={{ ...FONT.h5, color: COLOR.whiteText }}>What are my costs ?</span></Col>
            <Col xs={4} md={2}><Divider style={{ border: '1px solid #C1C1C1', margin: 0 }} /></Col>
            <Col xs={21} md={24}><span style={{ ...FONT.h6, color: COLOR.whiteText }}>Gas fee - please ensure you have at least 0.014 SOL in your Solana wallet for successful minting.</span></Col>
          </Row>
          <Row justify='center' style={{ textAlign: 'center', margin: '36px 0px' }}>
            <Col>
              <img src="./assets/star_up.gif" alt="" style={{ width: 30, marginRight: 10, marginLeft: 10 }} />
              <img src="./assets/star_down.gif" alt="" style={{ width: 30, marginRight: 10, marginLeft: 10 }} />
              <img src="./assets/star_up.gif" alt="" style={{ width: 30, marginRight: 10, marginLeft: 10 }} />
              <img src="./assets/star_down.gif" alt="" style={{ width: 30, marginRight: 10, marginLeft: 10 }} />
              <img src="./assets/star_up.gif" alt="" style={{ width: 30, marginRight: 10, marginLeft: 10 }} />
              <img src="./assets/star_down.gif" alt="" style={{ width: 30, marginRight: 10, marginLeft: 10 }} />
            </Col>
          </Row>
          {isMobile ?
            <Row justify='center' gutter={[0, 24]} style={{ textAlign: 'center' }}>
              <Col xs={21} md={24}><span style={{ ...FONT.h5, color: COLOR.whiteText }}>Why is Shiba9 NFT FREE?</span></Col>
              <Col xs={4} md={2}><Divider style={{ border: '1px solid #C1C1C1', margin: 0 }} /></Col>
              <Col xs={21} md={24}><span style={{ ...FONT.h6, color: COLOR.whiteText }}>We aim at bringing an experience to everyone with a minting tool developed by us
                and to lower users’ cost, in way to promote the technology to the public.</span></Col>
              <Col span={21}><span style={{ ...FONT.h6, color: COLOR.whiteText }}>All the income will be donated to charity with initial project cost deducted.</span></Col>
            </Row> :

            <Row justify='center' gutter={[0, 24]} style={{ textAlign: 'center' }}>
              <Col xs={21} md={24}><span style={{ ...FONT.h5, color: COLOR.whiteText }}>Why is Shiba9 NFT FREE?</span></Col>
              <Col xs={4} md={2}><Divider style={{ border: '1px solid #C1C1C1', margin: 0 }} /></Col>
              <Col xs={21} md={24}><span style={{ ...FONT.h6, color: COLOR.whiteText }}>We aim at bringing an experience to everyone with a minting tool developed by us
                <div />
                and to lower users’ cost, in way to promote the technology to the public.</span></Col>
              <Col span={21}><span style={{ ...FONT.h6, color: COLOR.whiteText }}>All the income will be donated to charity with initial project cost deducted.</span></Col>
            </Row>}
          <Row justify='center' style={{ textAlign: 'center', margin: '36px 0px' }}>
            <Col>
              <img src="./assets/star_up.gif" alt="" style={{ width: 30, marginRight: 10, marginLeft: 10 }} />
              <img src="./assets/star_down.gif" alt="" style={{ width: 30, marginRight: 10, marginLeft: 10 }} />
              <img src="./assets/star_up.gif" alt="" style={{ width: 30, marginRight: 10, marginLeft: 10 }} />
              <img src="./assets/star_down.gif" alt="" style={{ width: 30, marginRight: 10, marginLeft: 10 }} />
              <img src="./assets/star_up.gif" alt="" style={{ width: 30, marginRight: 10, marginLeft: 10 }} />
              <img src="./assets/star_down.gif" alt="" style={{ width: 30, marginRight: 10, marginLeft: 10 }} />
            </Col>
          </Row>
          {isMobile ?
            <Row justify='center' gutter={[0, 24]} style={{ textAlign: 'center' }}>
              <Col xs={23} md={24}><span style={{ ...FONT.h5, color: COLOR.whiteText }}>What are the blockchain technologies used?</span></Col>
              <Col xs={4} md={2}><Divider style={{ border: '1px solid #C1C1C1', margin: 0 }} /></Col>
              <Col xs={21} md={24}><span style={{ ...FONT.h6, color: COLOR.whiteText }}>Shiba9 NFT is hosted on Solana blockchain in Metaplex standard. <br /> Metaplex is a Solana protocol, with Candy Machine, <br /> an on-chain distributed program that works as a smart contract to create, <br />mint and visualize NFT in a standard way across applications.</span></Col>
            </Row> :

            <Row justify='center' gutter={[0, 24]} style={{ textAlign: 'center' }}>
              <Col xs={21} md={24}><span style={{ ...FONT.h5, color: COLOR.whiteText }}>What are the blockchain technologies used?</span></Col>
              <Col xs={4} md={2}><Divider style={{ border: '1px solid #C1C1C1', margin: 0 }} /></Col>
              <Col xs={21} md={24}><span style={{ ...FONT.h6, color: COLOR.whiteText }}>Shiba9 NFT is hosted on Solana blockchain in Metaplex standard. <br /> Metaplex is a Solana protocol, with Candy Machine, <br /> an on-chain distributed program that works as a smart contract to create, <br />mint and visualize NFT in a standard way across applications.</span></Col>
            </Row>}

          <Row justify='center' style={{ textAlign: 'center', margin: '36px 0px' }}>
            <Col>
              <img src="./assets/star_up.gif" alt="" style={{ width: 30, marginRight: 10, marginLeft: 10 }} />
              <img src="./assets/star_down.gif" alt="" style={{ width: 30, marginRight: 10, marginLeft: 10 }} />
              <img src="./assets/star_up.gif" alt="" style={{ width: 30, marginRight: 10, marginLeft: 10 }} />
              <img src="./assets/star_down.gif" alt="" style={{ width: 30, marginRight: 10, marginLeft: 10 }} />
              <img src="./assets/star_up.gif" alt="" style={{ width: 30, marginRight: 10, marginLeft: 10 }} />
              <img src="./assets/star_down.gif" alt="" style={{ width: 30, marginRight: 10, marginLeft: 10 }} />
            </Col>
          </Row>
          {isMobile ?
            <Row justify='center' gutter={[0, 24]} style={{ textAlign: 'center' }}>
              <Col xs={23} md={24}><span style={{ ...FONT.h5, color: COLOR.whiteText }}>Future of NFT <br />Can it be used for identity verification?
              </span></Col>
              <Col xs={4} md={2}><Divider style={{ border: '1px solid #C1C1C1', margin: 0 }} /></Col>
              <Col xs={21} md={24}><span style={{ ...FONT.h6, color: COLOR.whiteText }}>It is challenging for digital creators to proof their identity and ownership of their works. <br /> In fact, it is possible to link official ID to an NFT to verify a person's identity before transactions. <br /> With proper smart contracts in place on your NFT-verified online identity, <br /> the blockchain can grant full visibility into who has access to your data.</span></Col>
            </Row> :

            <Row justify='center' gutter={[0, 24]} style={{ textAlign: 'center' }}>
              <Col xs={21} md={24}><span style={{ ...FONT.h5, color: COLOR.whiteText }}>Future of NFT <br />Can it be used for identity verification?</span></Col>
              <Col xs={4} md={2}><Divider style={{ border: '1px solid #C1C1C1', margin: 0 }} /></Col>
              <Col xs={21} md={24}><span style={{ ...FONT.h6, color: COLOR.whiteText }}>It is challenging for digital creators to proof their identity and ownership of their works. <br /> In fact, it is possible to link official ID to an NFT to verify a person's identity before transactions. <br /> With proper smart contracts in place on your NFT-verified online identity, <br /> the blockchain can grant full visibility into who has access to your data.</span></Col>
            </Row>}

          <Row justify='center' gutter={[0, 24]}>
            <Col span={24}>
              {isMobile ?
                <Row justify='center' gutter={[0, 24]} style={{ textAlign: 'center', paddingTop: 30, marginBottom: 20 }}>
                  <Col span={24}><span style={{ ...FONT.smallContent, textAlign: 'center', color: COLOR.captionText }}> *Supply of the NFT is limited, available only
                    <div />while stocks last.  </span></Col>
                </Row> :
                <Row justify='center' gutter={[0, 24]} style={{ textAlign: 'center', paddingTop: 20, marginBottom: 20 }}>
                  <Col span={24}><span style={{ ...FONT.smallContent, textAlign: 'center', color: COLOR.captionText }}> *Supply of the NFT is limited, available only while stocks last.  </span></Col>
                </Row>}
            </Col>
          </Row>
        </Col>
      </Row>
    </TNContent>
  )
}

export default BlockchainFAQ;